import * as types from './mutation-types'
import authService from '../../services/authentication'
import { createServiceCall } from '../actionsUtil'

export const logout = createServiceCall({
  serviceFunction: authService.logout,
  successAction: types.LOGOUT
})

export const setSessionStatus = ({commit}) => {
  commit(types.SET_SESSION_STATUS)
}

export const locallyUpdateProfileSettings = ({commit}, preferences) => {
  commit(types.UPDATE_LOCAL_USER_SETTINGS, preferences);
}

export const locallyUpdateProfileTheme = ({commit}, theme) => {
  commit(types.UPDATE_LOCAL_USER_THEME, theme);
}

export const locallyUpdateProfilePushNotifications = ({commit}, allowPushNotifications) => {
  commit(types.UPDATE_LOCAL_USER_PUSH_NOTIFICATIONS, allowPushNotifications);
}

export const setSelectedRoleId = ({commit}, roleId) => {
  commit(types.SET_SELECTED_ROLE_ID, roleId)
}



export const setupAccount = createServiceCall({
  mainAction: types.SETUP_ACCOUNT_REQUEST,
  serviceFunction: authService.setupAccount,
  successAction: types.SETUP_ACCOUNT_SUCCESS,
  successDataProperty: "checkInvite",
  failureAction: types.SETUP_ACCOUNT_FAILURE
});

export const getMenuForCurrentUser = createServiceCall({
  serviceFunction: authService.getMenuForCurrentUser,
  successAction: types.GET_USER_MENUS_SUCCESS,
  failureAction: types.GET_USER_MENUS_FAILURE
});
